import React from 'react';
import Footer from '../../components/Layout/Footer';
import Header from '../../components/Layout/Header/Header';

export default function RefundPolicy() {
  return (
    <div className="template-index index-demo4">
      <div className="page-wrapper">
        <div className="classic-topHeader">
          <Header />
          <div id="page-content" className="mb-0">
            <div className="container mt-5 mb-5" style={{ minHeight: '50vh' }}>
              <h1 className="text-center mb-4">REFUND POLICY</h1>
              <div className="policy-content" style={{ maxWidth: '800px', margin: '0 auto', lineHeight: '1.8' }}>
                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                  <li className="mb-3">
                    <strong>Booking Cancellation by Customer:</strong>
                    <ul style={{ listStyleType: 'circle', paddingLeft: '20px', marginTop: '10px' }}>
                      <li className="mb-2"><strong>24+ Hours Before Pickup:</strong> Cancellations made 24 hours prior to the scheduled pickup time are eligible for a full refund or store credit for future bookings.</li>
                      <li className="mb-2"><strong>Less than 24 Hours Before Pickup:</strong> Cancellations made within 24 hours of the pickup time may incur a cancellation fee (e.g., 20% to 50% of the daily rental amount).</li>
                    </ul>
                  </li>
                  <li className="mb-3"><strong>Order Rejection by Adcaster:</strong> If Adcaster cancels a booking due to failed verification, non-availability of equipment, or technical issues, a 100% full refund will be processed immediately.</li>
                  <li className="mb-3"><strong>Refund Processing Time:</strong> Approved refunds will be credited back to the original payment method (Bank Account / UPI / Card) within 5 to 7 business days.</li>
                  <li className="mb-3"><strong>Early Return:</strong> No partial refunds will be issued if the customer returns the equipment earlier than the scheduled end date/time.</li>
                </ul>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}
